import React, { useEffect, useState,useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import IconRenderer from "../../common/iconRender.js";
import {
  Box,
  CardContent,
  Grid,
  Link,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import authActions from "../../redux/auth/actions";
import { HiArrowLongRight } from "react-icons/hi2";
import reg from "../../../src/assets/images/sidebar/registration.svg";
import scorecard from "../../../src/assets/images/sidebar/score card.svg";
import objection from "../../../src/assets/images/sidebar/objection-tracker.svg";
import checklist from "../../../src/assets/images/sidebar/checklist.png";
import survey from "../../../src/assets/images/sidebar/survey.png";
import user from "../../../src/assets/images/sidebar/user.png";
import bell from "../../../src/assets/images/sidebar/bell-school.png";
import credit from "../../../src/assets/images/sidebar/creditcard.png";
import doubts from "../../../src/assets/images/sidebar/doubts-button.png";
import idBadge from "../../../src/assets/images/sidebar/id-badge.png";
import idCard from "../../../src/assets/images/sidebar/id-card.png";
import keycloakService from "../../modules";
import MobileVerification from "./mobileverification.js"
import {
  DecryptFunction,
  DecryptObjectFunction,
} from "../../utils/cryptoFunction";
import candidatesActions from "../../redux/candidates/actions";
import objectionTrackActions from "../../redux/objectionTracker/actions";

export default function Index() {
   const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [wrongOTP, setWrongotp] = useState(0);
  const [attempt, setAttempt] = useState(0);
  const [red, setRed] = useState(false);
 const [error, setError] = useState("");
 const [resendCountdown, setResendCountdown] = useState(120);
 const [timer, setTimer] = useState(null);
 const [timeRemaining, setTimeRemaining] = useState(30 * 60);
 const [timeRemainingmin, setTimeRemainingmin] = useState(0);
 const [timeRemainingsec, setTimeRemainingsec] = useState(0);
const[openDialog,setOpenDialog]=useState(false);
// const candidateid = useSelector(
//   (state) => state?.authReducer?.candidateTokenDetails?.candidateid
// );

const ProfileSummaryDetails = useSelector(
  (state) => state.authReducer.ProfileSummaryDetails
);
const item = useSelector(
  (state) => state.authReducer.menuDetails
);

const {
  candidateid,
  candidatename,
  mobilenoverified,
  profiledetailstatus,
  addressdetailstatus,
  otherdetailstatus,
  uploaddetailstatus,
} = ProfileSummaryDetails?.[0] || {};
const profileSummaryLoaded = useSelector(
  (state) => state.authReducer.profileSummaryLoaded
);
// useEffect(()=>{
//   dispatch({type:authActions.GET_PROFILE_SUMMARY})
// },[])
// console.log(ProfileSummaryDetails,"Prashanth")
// useEffect(() => {
//   if (candidateid) {
//     dispatch({
//       type: objectionTrackActions.GET_OBJECTION_COURSES,
//       payload: { candidateid },
//     });
//   }
// }, [candidateid]);
// const { objectionCourses } = useSelector(
//   (state) => state.objectionTrackerReducer
// );
  const[mobileverified,setMobileVerified]=useState(false)
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // const { candidateTokenDetails, profileRegistrationActiveTab } = useSelector(
  //   (state) => state.authReducer
  // );
  const { clickable} = useSelector((state) => state.commonReducer);

  useEffect(() => {
    // dispatch({ type: candidatesActions.GET_UPLOAD_PERSONAL_DETAILS });
    
     const now = new Date();
   const endTime = new Date(sessionStorage.getItem("otpSignupEndTime"));
 // gdgd
   if (endTime && endTime > now) {
     const difference = endTime - now;
     const remainingSeconds = Math.floor((difference / 1000) % 60);
     const remainingMinutes = Math.floor((difference / (1000 * 60)) % 60);
 
     setTimeRemaining(remainingMinutes * 60 + remainingSeconds);
     setTimeRemainingmin(
       formatTime(difference ? timeRemainingmin : remainingMinutes)
     );
     setTimeRemainingsec(
       formatTime(difference ? timeRemainingsec : remainingSeconds)
     );
 
     // startTimer(remainingMinutes * 60 + remainingSeconds);
   }
  }, [candidateid]);
  
  const { personalDetails, uploadDetails, addressDetails, otherDetails } =
    useSelector((state) => state.candidatesReducer);



  
// useEffect(()=>{
//   if(uploadDetails){

//     if(allProfiledetailsDraft && sessionStorage.getItem('mhet_cnd_mobileno_verified') == "true"){
//       navigate(
//         `/${sessionStorage.getItem("mhet_cnd_project")}/registration?page=personaldetails`
//       );
//     }
//   }

// },[uploadDetails])
// useEffect(() => {
//   const mobileOtpFlag = sessionStorage.getItem("mobileotp") === "true";
// if (mobileOtpFlag) {
//     // ✅ OTP logic ya koi aur dialog yaha karo
//     // setOpenDialog(true);
//     // dispatch({
//     //   type: authActions.SEND_OTP_FOR_MOBILE_VERIFICATION,
//     //   payload: {
//     //     data: {
//     //       // mobileno: sessionStorage.getItem("mhet_cnd_mobileno"),
//     //       candidatename,
//     //     },
//     //   },
//     // });
//     setResendCountdown(120);
//   }else{
//     return
//   }
// }, [sessionStorage.getItem("mobileotp")]);
// alert(profileSummaryLoaded.length)
// useEffect(()=>{
//   if(profileSummaryLoaded!==null || profileSummaryLoaded!==undefined)
//     {
//       dispatch({type:authActions.VERIFY_MOBILENO_FOR_SIGNUP,
//         payload: { data: { emailid: sessionStorage.getItem('mhet_cnd_email'),
//           dob:sessionStorage.getItem('mhcet_dob'),
//           candidatename:sessionStorage.getItem('mhcet_name'),
//           sso:sso, navigate: navigate } },})
//     }
// },[profileSummaryLoaded==undefined])




  let now = new Date();
  let endTime = new Date(sessionStorage.getItem("otpSignupEndTime"));
  let difference = endTime - now;
  function formatTime(number) {
    return number < 10 ? "0" + number : number;    
  }
  const allProfiledetailsDraft = uploadDetails?.[0]?.statusmain ? true : false;
//   useEffect(() => {
  
//  }, []);
 useEffect(() => {
   let remainingSeconds = Math.floor((difference / 1000) % 60);
   let remainingMinutes = Math.floor((difference / (1000 * 60)) % 60);
   setTimeRemainingmin(formatTime(remainingMinutes));
   setTimeRemainingsec(formatTime(remainingSeconds));
   
 });
 
 useEffect(() => {
   if (timeRemainingmin == 0) {
     setAttempt(0);
     setWrongotp(0);
     setResendCountdown(0);
   }
 },[timeRemainingmin])

//  const candidatename = keycloakService?.getUserInfo('name')?.toUpperCase() || '';
 const emailid = keycloakService?.getUserInfo('email');
 const mobileno = keycloakService?.getUserInfo('phone_number');
 const dob = keycloakService?.getUserInfo('birthdate');
const isEmailChanged =  false;
const temppassword =  '';
const sso = keycloakService?.keycloakTokenParsed()?.sub
const data = { candidatename,
  emailid,
  mobileno,
  temppassword,
  dob,
  isEmailChanged,sso}



   const paymentReceiptList = useSelector(
      (state) => state.candidatesReducer?.paymentReceiptList
    );
    useEffect(() => {
      if (candidateid) {
        dispatch({
          type: "GET_PAYMENT_RECEIPT_LIST",
          payload: { candidateid: candidateid },
        });
      }
    }, [candidateid]);
    
  let isCardOpen = paymentReceiptList?.some((val) => val?.statustext === 'Paid')
  


  // sessionStorage.setItem("mhet_cnd_mobileno",mobileno) 
  useEffect(() => {
    if(emailid ){
  //  dispatch({
  //       type: authActions.CHECK_MOBILE_VERIFIED,
  //       payload: {
  //         navigate: navigate,
  //         data: data,
  //         setResendCountdown: setResendCountdown,
  //         setOpenDialog: setOpenDialog,
  //         dispatch:dispatch,
  //         navigate:navigate,
  //         uploadDetails:uploadDetails,
  //       },
  //     });
    }
    //   sessionStorage.setItem("mhet_cnd_mobileno",mobileno) 
    // const setMobileNo = ()=>{ const setMobno =  sessionStorage.getItem("mhet_cnd_mobileno") ? null : sessionStorage.setItem("mhet_cnd_mobileno",mobileno)  }
  
    // setMobileNo()

  }, [emailid,
    mobileno,
    temppassword,
    dob,
    isEmailChanged]);
  

  // useEffect(() => {

  //   // if (sessionStorage.getItem('mhet_cnd_email_verified') == 'true') {

  //   //     navigate(`/${sessionStorage.getItem('mhet_cnd_project')}/verify-mobileno`);
  //   //   }
  
  //   const setProject = keycloakService.getIsAuthenticated() ? sessionStorage.setItem('mhet_cnd_project','mhcet') : null

  //   // if (candidateTokenDetails?.candidateid) {
  //   //   dispatch({
  //   //     type: authActions.GET_PROFILE_REGISTRATION_ACTIVE_TAB,
  //   //     payload: { id: candidateTokenDetails?.candidateid },
  //   //   });
  //   // }
  // }, [candidateid]);
//    const isStatusReady = useMemo(() => {
//   return [profiledetailstatus, addressdetailstatus, otherdetailstatus, uploaddetailstatus].every(
//     (val) => val !== undefined
//   );
// }, [profiledetailstatus, addressdetailstatus, otherdetailstatus, uploaddetailstatus]);
// const profileRegistrationActiveTab = useMemo(() => {
//     if (!isStatusReady) return

//     if (profiledetailstatus === 2 && addressdetailstatus === 2 && otherdetailstatus === 2 && uploaddetailstatus === 2) return "new";
//     else{
//       return "personaldetails"
//     } // all completed
//   }, [isStatusReady, profiledetailstatus, addressdetailstatus, otherdetailstatus, uploaddetailstatus]);
// useEffect(() => {
//   if (!profileRegistrationActiveTab) return;

//   const project = sessionStorage.getItem("mhet_cnd_project");

//   switch (profileRegistrationActiveTab) {
//     case "personaldetails":
//       navigate(`/${project}/registration?page=personaldetails`);
//       break;
//     case "address":
//       navigate(`/${project}/registration?page=address`);
//       break;
//     case "otherdetails":
//       navigate(`/${project}/registration?page=otherdetails`);
//       break;
//     case "uploads":
//       navigate(`/${project}/registration?page=uploads`);
//       break;
//     case "new":
//       navigate(`/${project}/home`);
//       break;
//     default:
//       break;
//   }
// }, [profileRegistrationActiveTab]);

 const items = useMemo(() => {
  if (!item || !Array.isArray(item)) return [];

  return item
    .filter((entry) => entry.is_homemenu_enabled === true).map((entry) => {
    const menuCode = entry.menu_code;
    const projectPath = `/${sessionStorage.getItem("mhet_cnd_project")}`;

    let finalPath = "";
    let isDisabled = false;

    // Handle path & disabled logic here based on business rules
    switch (menuCode) {
      case "PROFILE":
        finalPath = `${projectPath}/registration?page=personaldetails`;
        break;

      case "CET_REGISTRATION":
        if ( clickable) {
          finalPath = `${projectPath}/course-selection`;
        } else {
          isDisabled = true;
        }
        break;

      case "PAYMENT_HISTORY":
        finalPath = `${projectPath}/payment-receipts`;
        break;

      case "HALL_TICKET":
        finalPath = isCardOpen && clickable ? `${projectPath}/admit-card-list` : "";
        isDisabled = !isCardOpen;
        break;

      case "SCORE_CARD":
        finalPath = isCardOpen && clickable ? `${projectPath}/scorecard` : "";
        isDisabled = !isCardOpen;
        break;

      case "OBJECTION_TRACKER":
        finalPath = isCardOpen && clickable ? `${projectPath}/answer-key?page=tablelist` : "";
        isDisabled = !isCardOpen;
        break;

      case "CAP_REGISTRATION":
        finalPath = `${projectPath}/cap-landingpage`;
        isDisabled = true;
        break;

      case "HELP_DESK":
        finalPath = `${projectPath}/raise-query`;
        break;

      case "CET_NOTIFICATION":
        finalPath = `${projectPath}/cet-notification`;
        break;

      case "CAP_NOTIFICATION":
        finalPath = `${projectPath}/cap-notification`;
        isDisabled = true;
        break;

      case "ARA":
        finalPath = `${projectPath}/ara`;
        isDisabled = true;
        break;

      case "RESPONSE_SHEET":
        finalPath = `${projectPath}/response-sheet`;
        isDisabled = true;
        break;

      default:
        finalPath = entry.path ? `${projectPath}/${entry.path}` : "";
    }
if (entry.is_active === false) {
        isDisabled = true;
      }
    return {
      ...entry,
      icon: (
        <IconRenderer
          index={entry.menu_code}
          iconName={entry.icon}
          named="Home"
          width="58px"
          height="58px"
          filter="brightness(0) saturate(100%) invert(21%) sepia(35%) saturate(3938%) hue-rotate(199deg) brightness(93%) contrast(93%)"
        />
      ),
      path: finalPath,
      disabled: isDisabled,
    };
  });
}, [item, uploaddetailstatus, isCardOpen, clickable]);

 

  return (
    <Grid container spacing={3} >
      {items.map((item, index) => (
        <Grid item sm={12} md={6} lg={4} key={index}>
          <Paper
            elevation={1}
            sx={{
              padding: 2,
              minHeight: 120,
              height: "100%",
              maxWidth: 450,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // cursor: item.disabled ? "not-allowed" : clickable ?  "pointer": "wait" ,
              cursor: item.disabled ? "not-allowed" : "pointer" ,
              opacity: item.disabled ? 0.6 : 1,
              backgroundColor: item.disabled ? "#f0f0f0" : "#fff",
              pointerEvents: item.disabled ? "none" : "auto",
            }}
            onClick={() => {
  if (!item.disabled && item.path) {
    navigate(item.path);
  }
  if (item?.link) {
    window.open("https://cetcell.mahacet.org/notices", "_blank");
  }
            }}
          >
            <Grid container alignItems="center">
              <Grid
                item
                sm={4}
                xs={12}
                md={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    color: item.disabled ? "#9e9e9e" : "#0F4F96",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: 62,
                    height: 65,
                    opacity: item.disabled ? 0.5 : 1,
                  }}
                >
                  {item.icon}
                </Box>
              </Grid>
              <Grid item sm={6} xs={12} md={8}>
                <CardContent sx={{ padding: "16px " }}>
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{
                      fontSize: 16,
                      fontWeight: 500,
                      fontFamily: "inter",
                      textAlign: isMobile ? "center" : "start",
                    }}
                  >
                    {item.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: 12,
                      fontWeight: 400,
                      color: "#5683B5",
                      paddingTop: "7px",
                      textAlign: isMobile ? "center" : "start",
                    }}
                  >
                    {item.details}
                  </Typography>
                </CardContent>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ textAlign: isMobile ? "center" : "end" }}
              >
                <HiArrowLongRight
                  size={20}
                  style={{
                    color: "#5683B5",
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      ))}
      <MobileVerification 
       otp={otp}
       setOtp={setOtp}
       error={error}
       setError={setError}
       setResendCountdown={setResendCountdown}
       resendCountdown={resendCountdown}
       setWrongotp={setWrongotp}
       attempt={attempt}
       wrongOTP={wrongOTP}
       red={red}
       setRed={setRed}
       setAttempt={setAttempt}
       timeRemaining={timeRemaining}
       setTimeRemaining={setTimeRemaining}
       timeRemainingmin={timeRemainingmin}
       setTimeRemainingmin={setTimeRemainingmin}
       timeRemainingsec={timeRemainingsec}
       setTimeRemainingsec={setTimeRemainingsec}
      mobileno={mobileno}
      timer={timer}
      setTimer={setTimer}
      difference={difference}
      mobileverified={mobileverified}
      setMobileVerified={setMobileVerified}
      openDialog={openDialog}
      setOpenDialog={setOpenDialog}
      />
    </Grid>
  );
}